export default __webpack_public_path__ + "static/media/payment_failed.92c07e24.svg";